export default function selectIntegrationCredentialsBase(state) {
  return state.integrations.credentials
}
